export default __webpack_public_path__ + "static/media/mr_mrs_smith_xl3.047c4ee7.png";